import { render } from "./KubernetesInstallation.vue?vue&type=template&id=793d2fdd"
import script from "./KubernetesInstallation.vue?vue&type=script&lang=js"
export * from "./KubernetesInstallation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__